module.exports = __webpack_public_path__ + "img/Vencasa-Payment-Icon-Green.d3baf1b7.webp";